module.exports = __webpack_public_path__ + "img/logo-light.b67f7ab7.svg";